import pl from "@locales/availability/pl.json";
import en from "@locales/availability/en.json";

export default { pl, en };
